import { Fragment } from "react";
import "./FreeConsultButton.css";
export default function FreeConsultButton() {
  return (
    <Fragment>
      <button className="freeConsultBtn">GET A FREE CONSULTATION</button>
    </Fragment>
  );
}
